import { useSelector } from "react-redux";
import {
  put,
  takeEvery,
  takeLatest,
  all,
  select,
  delay,
  call
} from "redux-saga/effects";
import { ADD_TASK_TO_TASKLIST, POLL_TASKS } from "../constants/actionTypes";
import axios from "axios";
import { AddTaskToTaskList, SetTaskList } from "../actions";
const apiCall = (token, endpoint, type = "GET", data = "") =>
  axios({
    method: type,
    headers: {
      Authorization: "bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: process.env.REACT_APP_API_URL + endpoint,
    withCredentials: true,
    data: data,
    errorHandle: false
  });

function* pollTasks() {
  const getToken = state => state.userAccess.token;
  const token = yield select(getToken);
  const response = yield apiCall(token, "/v1/tasks", "GET").then(
    response => response
  );
  yield put(SetTaskList(response.data.Data));
}

function* pollTasksPeriodically() {
  while (true) {
    yield call(pollTasks);
    yield delay(20000);
  }
}

function* actionWatcher() {
  yield takeLatest(POLL_TASKS, pollTasksPeriodically);
}

function* rootSaga() {
  yield all([actionWatcher()]);
}

export default rootSaga;
